import { t } from 'ttag'
import { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Globals } from '@h2/globals'
import { SignInOrRegisterDialog } from '@h2/common/components/header/signInOrRegisterDialog'

import { signinDialogTabClick } from '../actions/signinOrRegisterDialog'

const REGISTRATION_PANEL = 'createAccount'
const SIGNIN_PANEL = 'signIn'
const RequireSignIn = props => {
  const { children } = props
  const { userProfile } = useContext(Globals)
  const dispatch = useDispatch()
  const [currentPanel, setCurrentPanel] = useState(SIGNIN_PANEL)
  const signedIn = !!userProfile
  const {
    isPremium = false,
    hasSchoolAdmin = false,
    hasManager = false,
    hasAdmin = false,
    isRoot = false
  } = signedIn && userProfile
  const pageName = props.name || t`this page`
  const adminOnly = props.adminOnly ?? false
  const includePremium = props.includePremium ?? false
  const includeSchoolAdmin = props.includeSchoolAdmin ?? false
  const includeManager = props.includeManager ?? false

  useEffect(() => {
    dispatch(signinDialogTabClick(currentPanel))
  }, [dispatch, currentPanel])

  const detourHandler = () => {
    setCurrentPanel(currentPanel === SIGNIN_PANEL ? REGISTRATION_PANEL : SIGNIN_PANEL)
  }

  if (!signedIn) {
    return (
      <SignInOrRegisterDialog
        useModal={false}
        customDetourHandler={detourHandler}
        addMessage={t`You must login before you can access ${pageName}`}
      />
    )
  }

  if (
    adminOnly &&
    !(
      hasAdmin ||
      isRoot ||
      (includeSchoolAdmin && hasSchoolAdmin) ||
      (includeManager && hasManager) ||
      (includePremium && isPremium)
    )
  ) {
    return (
      <div className="container">
        <div className="alert alert-warning">{t`You must be an administrator to access this page`}</div>
      </div>
    )
  }

  return children
}

RequireSignIn.propTypes = {}
RequireSignIn.defaultProps = {}

export default RequireSignIn
